import { PlanningsMapGaragePositionEntity } from 'src/entities/PlanningsMapGaragePosition.entity';

export type ResolvedGarage = { name: string; address?: string };

/**
 * 展開行の発地に出す車庫を deliveryId から引く。
 * 引けなければ undefined を返し、呼び出し側は発地行を出さない（仮の値で埋めない）。
 *
 * 住所は同名の車庫を見分けるために出す。空文字は「未登録」なので undefined に
 * 畳んで、呼び出し側が空行を描かずに済むようにする。
 */
export function resolveGarageByDeliveryId(
  garages: readonly PlanningsMapGaragePositionEntity[],
  deliveryId: number,
): ResolvedGarage | undefined {
  const found = garages.find((g) => g.deliveryIds.includes(deliveryId))?.garageEntity;
  if (!found) return undefined;
  return { name: found.name, address: found.address || undefined };
}
